import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { ChannelService } from '../../../../../services/channel.service';
import { FormArray, FormControl, FormGroup } from '@angular/forms';
import { IFormAiConfig } from './integration-ai.interface';
import { NotificationService } from '../../../../../services/notifications.service';
import { BaseService } from '../../../../../services/base.service';
import { AiService } from '../../../../../services/ai.service';
import { DEFAULT_ERROR, ERROR_MESSAGES, activeTranslations } from '../../../../../enum/constants';
import { PaymentService } from '../../../../../services/payment.service';
import { IError } from '../../../../../interfaces';
import { CrmService } from '../../../../../services/crm.service';

@Component({
  selector: 'app-integration-ai',
  templateUrl: './integration-ai.component.html',
  styleUrl: './integration-ai.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class IntegrationAiComponent implements OnInit {
  @Input() payload: any;
  @Output() close = new EventEmitter<any>();

  channels = [];
  currentChannels: any[] = [];
  controllers: any = [];
  controlChannel: any = [];
  public settingsAi: any[] = [];
  public crmConfig: any;
  public aiPrice: any;

  formAiConfig!: FormGroup<IFormAiConfig>;

  constructor(
    private readonly channelService: ChannelService,
    private readonly notificationService: NotificationService,
    public readonly baseService: BaseService,
    private readonly aiService: AiService,
    private readonly paymentService: PaymentService,
    private readonly crmService: CrmService,
  ) {}

  ngOnInit() {
    this.channelService.getChannels({ scope: 'integration' }).subscribe((res) => {
      this.channels = res;
      this.currentChannels = res;
      this.getAiSettings();
    });
    this.getConfig();
  }

  onChangeChannel(event?: any) {
    // const channelIds: any[] = [];
    // this.controlChannel = this.formAiConfig.getRawValue();
    // (this.controlChannel.integrations as any).forEach((v: any) => {
    //   channelIds.push(...v.channels.map((item: any) => item.id));
    // })
    // this.controllers = channelIds;
    // this.currentChannels = this.channels.map((v: any) => {
    //   v.isdisabled = this.controllers.includes(v.id);
    //   return v;
    // });
  }

  onOpen(event: any) {
    this.controlChannel = this.formAiConfig.getRawValue();

    const channelIds = this.controlChannel.integrations.flatMap((v: any) => v.channels.map((item: any) => item.id));
    const currentChannels = (event.controls.channels.value || []).map((v: any) => v.id);
    this.currentChannels = this.channels.map((v: any) => {
      v.disabled = channelIds.includes(v.id) && !currentChannels.includes(v.id);
      return v;
    });
  }

  public initForm() {
    if (this.settingsAi.length) {
      this.formAiConfig = new FormGroup({
        integrations: new FormArray([]),
      });

      const integrationsArray = this.formAiConfig.get('integrations') as FormArray;

      this.settingsAi.forEach((v: any) => {
        const channels = v.channels.map((channel_id: string) =>
          this.channels.find((channel: any) => channel.id === channel_id),
        );
        const integrationGroup = new FormGroup({
          text: new FormControl(v.prompt),
          token_output: new FormControl(v.token_output),
          channels: new FormControl(channels),
        });
        integrationsArray.push(integrationGroup);
      });
    } else {
      this.formAiConfig = new FormGroup<IFormAiConfig>({
        integrations: new FormArray([
          new FormGroup({
            text: new FormControl(),
            token_output: new FormControl(),
            channels: new FormControl(),
          }),
        ]),
      });
    }
    this.onChangeChannel();
    // const selectedChannelIds = this.settingsAi.flatMap((value: any) => value.channels || []);
    //
    // this.currentChannels = this.channels.filter((channel: any) => !selectedChannelIds.includes(channel.id));
  }

  getConfig() {
    this.crmService.getConfig().subscribe({
      next: (config) => {
        this.crmConfig = config;
        this.aiPrice = config.ai_token_price;
      },
      error: (e) => {
        (e.error?.errors || []).forEach((err: IError) => {
          this.notificationService.showError('', ERROR_MESSAGES[err.code] || ERROR_MESSAGES[DEFAULT_ERROR]);
        });
      },
    });
  }

  getIntegrations() {
    return this.formAiConfig.get('integrations') as FormArray;
  }

  addIntegration() {
    const integrations = this.formAiConfig.controls.integrations as FormArray;
    integrations.push(
      new FormGroup({
        text: new FormControl(''),
        token_output: new FormControl(),
        channels: new FormControl([]),
      }),
    );
  }

  save() {
    const items = ((this.formAiConfig.getRawValue().integrations as any) || []).map((v: any) => {
      return {
        text: v.text,
        token_output: v.token_output,
        channels: v.channels.map((channel: any) => channel.id),
      };
    });
    this.aiService.saveAiSettings(items).subscribe(() => {
      this.notificationService.showSuccess(
        '',
        activeTranslations.notifications_texts.success.successfully_saved,
      );
    });
  }

  getAiSettings() {
    this.aiService.getAiSettings().subscribe((v) => {
      this.settingsAi = v;
      this.initForm();
    });
  }

  deleteField(index: any) {
    this.getIntegrations().removeAt(index);
    this.onChangeChannel();
  }
}
